import { DEFAULTS } from "./defaults.js";
import { FILE_UPLOAD_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers.js";
const pluginFileUpload = (config) => {
  return {
    config: { ...DEFAULTS.configViewer, ...config },
    type: FILE_UPLOAD_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginFileUpload
};
//# sourceMappingURL=viewer.js.map
